<template>
  <div>
    <vs-tabs position="left" class="tabs-shadow-none" v-if="profile">
      <vs-tab icon-pack="feather" icon="icon-info" label="General" v-if="hasPermission('vp.crm.guestprofiles.view')">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <UserProfileGeneral :userProfile="profile" />
        </div>
      </vs-tab>
      <!-- <vs-tab
        icon-pack="feather"
        icon="icon-map-pin"
        label="Values"
        v-if="hasPermission('vp.crm.guestprofiles.extended.view')"
      >
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <guest-values />
        </div>
      </vs-tab> -->
      <vs-tab icon-pack="feather" icon="icon-link" label="Agreements" v-if="hasPermission('vp.crm.guestprofiles.view')">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <UserProfileConsents :userProfile="profile" />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-map-pin" label="PII sources" v-if="hasPermission('vp.crm.guestprofiles.extended.view')">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <UserProfileFieldSources :userProfile="profile" />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-book" label="Event log" v-if="hasPermission('vp.crm.guestprofiles.extended.view')">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <UserProfileLogs :userProfile="profile" />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-book" label="Log (legacy)" v-if="hasPermission('vp.crm.guestprofiles.extended.view')">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <guest-profile-logs />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import UserProfileGeneral from "./UserProfileGeneral.vue";
import UserProfileConsents from "./UserProfileConsents.vue";
import GuestProfileLogs from "./GuestProfileLogs.vue";
import UserProfileLogs from "./UserProfileLogs.vue";
import UserProfileFieldSources from "./UserProfileFieldSources.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    UserProfileGeneral,
    UserProfileConsents,
    GuestProfileLogs,
    UserProfileLogs,
    UserProfileFieldSources
  },
  data() {
    return {
      profile: null
    };
  },
  computed: {
    ...mapGetters({
      activeCountryId: "venues/activeCountryId"
    })
  },
  async created() {
    this.$vs.loading();
    this.profileId = this.$route.params.id;
    await Promise.all([this.$store.dispatch("guestSegmentation/get"), this.$store.dispatch("legalDocuments/getAllGuestPermissions")]);

    this.profile = await this.$store.dispatch("userProfiles/getUserProfile", { country: this.activeCountryId, userId: this.profileId });
    this.$vs.loading.close();
  }
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>